import React from 'react';
import { FaCheck, FaCircle } from 'react-icons/fa6';
import banner from "../../../assets/Image/selzor_main_banner.png";

const Banner = () => {
  return (
    <div className="relative overflow-hidden pt-10 pb-20 sm:pb-20 lg:pb-36" 
        style={{
          backgroundImage: `url('${banner}')`,
          backgroundSize: 'cover', 
          backgroundPosition: 'center', 
          backgroundRepeat: 'no-repeat', 
          minHeight: '50vh', 
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center', 
          paddingTop: '80px',
        }}>
      {/* Overlay for better text readability */}
      {/* <div className="absolute inset-0 bg-white opacity-40"></div>
       */}
      {/* Container similar to Bootstrap */}
      <div className="relative container mx-auto px-4 py-16 md:py-24 lg:py-32">
        <div className="max-w-8xl text-left">
          {/* Heading */}
          <h1 className="text-md md:text-md lg:text-md font-medium text-gray-700 mb-4">
            B2B ORDERING SYSTEM
          </h1>

          {/* Subheading */}
          <h1 className="max-w-8xl mx-auto text-6xl sm:text-6xl font-bold text-gray-900 leading-tight my-8"> { }
            <span className='text-[#1a9588] font-bold'>Selzor</span> – B2B Orders Placed by Approved Buyers
          </h1>

          {/* Features with check icons */}
          <div className="flex flex-wrap items-center mb-8">
            {/* First item - no circle before */}
            <div className="flex items-center">
              <span className="pr-2 text-[#1a9588] text-md font-medium">Buyer-Placed</span>
            </div>

            {/* Circle + Second item */}
            <div className="flex items-center">
              <FaCircle className="text-xs mx-1 text-gray-400" />
              <span className="px-2 text-[#1a9588] text-md font-medium">Sales-Enabled</span>
            </div>

            {/* Circle + Third item */}
            <div className="flex items-center">
              <FaCircle className="text-xs mx-1 text-gray-400" />
              <span className="px-2 text-[#1a9588] text-md font-medium">Delivery-Ready</span>
            </div>

            {/* Circle + Fourth item */}
            <div className="flex items-center">
              <FaCircle className="text-xs mx-1 text-gray-400" />
              <span className="px-2 text-[#1a9588] text-md font-medium">Fulfilment-Ready</span>
            </div>
          </div>
          {/* Description */}
          <p className="text-xl md:text-2xl text-gray-500 mb-8 leading-relaxed">
            SELZOR is your always-on sales enabler, empowering buyers to place orders at will.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 ">
            <button className="px-8 py-4 bg-[#1a9588] hover:bg-[#0f5851] text-white font-bold text-lg rounded-full transition duration-300 shadow-lg hover:shadow-xl transform ">
              Enable Buyer-Placed Ordering
            </button>
            <button className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-black text-[#1a9588] font-bold text-lg rounded-full transition duration-300 transform hover:-translate-y-1">
              See How It Works
            </button>
          </div>

          
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white border-opacity-70 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white bg-opacity-70 rounded-full mt-2"></div>
        </div>
      </div>
    </div>
  );
};

export default Banner;